// ============================================================================
//  ProfileModal.jsx — edit your own display name and photo.
// ============================================================================

import React, { useState, useRef } from "react";
import { X, Save, Camera } from "lucide-react";
import {
  C, display, overlay, sheet, lbl, inp, primaryBtn, smallBtn, smallGhost, iconBtn,
} from "../theme/tokens.js";
import { Avatar } from "../theme/primitives.jsx";

export default function ProfileModal({ person, onSave, onClose }) {
  const [name, setName] = useState(person?.name ?? "");
  const [photo, setPhoto] = useState(person?.photo ?? "");
  const [err, setErr] = useState("");
  const fileRef = useRef();

  const pickFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 1.4 * 1024 * 1024) {
      setErr("Image is large — try one under ~1.4MB so it saves reliably.");
      return;
    }
    const reader = new FileReader();
    reader.onload = () => { setPhoto(reader.result); setErr(""); };
    reader.readAsDataURL(file);
  };

  return (
    <div onClick={onClose} style={overlay}>
      <div onClick={(e) => e.stopPropagation()} style={{ ...sheet, maxWidth: 460 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ ...display, fontSize: 22, margin: 0, color: C.text }}>Profile</h3>
          <button onClick={onClose} style={iconBtn}><X size={18} /></button>
        </div>

        <div style={{ display: "flex", justifyContent: "center", margin: "22px 0 6px" }}>
          <Avatar person={{ name, photo }} size={92} />
        </div>

        <div style={{ marginTop: 16 }}>
          <label style={lbl}>Name</label>
          <input value={name} onChange={(e) => setName(e.target.value)} style={inp} />
        </div>

        <div style={{ marginTop: 18 }}>
          <label style={lbl}>Photo <span style={{ color: C.faint, fontWeight: 400 }}>· optional</span></label>
          <div style={{ marginTop: 9, display: "flex", alignItems: "center", gap: 10 }}>
            <button onClick={() => fileRef.current?.click()} style={smallBtn}>
              <Camera size={14} /> {photo ? "Change photo" : "Upload from device"}
            </button>
            {photo && (
              <button onClick={() => setPhoto("")} style={smallGhost}>Remove</button>
            )}
            <input ref={fileRef} type="file" accept="image/*" onChange={pickFile} style={{ display: "none" }} />
          </div>
        </div>
        {err && <div style={{ fontSize: 12, color: C.redDk, marginTop: 8 }}>{err}</div>}

        <button onClick={() => { if (name.trim()) onSave({ name: name.trim(), photo }); }}
          style={{ ...primaryBtn, width: "100%", marginTop: 24 }}>
          <Save size={16} /> Save profile
        </button>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/*  INVITE MODAL — admin / mentor invites a man (Edge Function)        */
/* ------------------------------------------------------------------ */
